import React from 'react';
import { useTranslation } from 'react-i18next';
import { 
  Cloud, 
  Sun, 
  CloudRain, 
  Wind, 
  CloudLightning, 
  CloudSnow,
  CloudDrizzle,
  Sunset
} from 'react-feather';

interface Props {
  description: string;
  size?: 'sm' | 'md' | 'lg';
}

const WeatherIcon: React.FC<Props> = ({ description, size = 'md' }) => {
  const { t } = useTranslation();
  
  const sizes = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-10 h-10'
  };

  // Map weather descriptions to icons
  const getIcon = (desc: string) => {
    const d = desc.toLowerCase();
    
    if (d.includes('thunderstorm')) return CloudLightning;
    if (d.includes('drizzle')) return CloudDrizzle;
    if (d.includes('rain') || d.includes('shower') || d.includes('precipitation')) return CloudRain;
    if (d.includes('snow') || d.includes('sleet') || d.includes('ice')) return CloudSnow;
    if (d.includes('fog') || d.includes('mist') || d.includes('rime')) return Cloud;
    if (d.includes('cloud') || d.includes('overcast')) return Cloud;
    if (d.includes('clear') || d.includes('sunny') || d.includes('mainly clear')) return Sun;
    if (d.includes('wind')) return Wind;
    
    return Sun; // Default
  };

  const Icon = getIcon(description);
  
  const getColor = (desc: string) => {
    const d = desc.toLowerCase();
    
    if (d.includes('thunderstorm')) return 'text-yellow-500';
    if (d.includes('rain') || d.includes('shower') || d.includes('drizzle') || d.includes('precipitation')) 
      return 'text-blue-500';
    if (d.includes('snow') || d.includes('sleet') || d.includes('ice')) 
      return 'text-blue-200';
    if (d.includes('fog') || d.includes('mist') || d.includes('rime')) 
      return 'text-gray-400';
    if (d.includes('cloud') || d.includes('overcast')) 
      return 'text-gray-500';
    if (d.includes('clear') || d.includes('sunny') || d.includes('mainly clear')) 
      return 'text-yellow-500';
    if (d.includes('wind')) 
      return 'text-blue-400';
    
    return 'text-gray-500';
  };

  return (
    <div className="flex flex-col items-center gap-2">
      <Icon className={`${sizes[size]} ${getColor(description)}`} />
      {size !== 'sm' && (
        <span className="text-sm text-gray-600 text-center">{description}</span>
      )}
    </div>
  );
};

export default WeatherIcon;